import { render, staticRenderFns } from "./CalificacionesParcialesPage.vue?vue&type=template&id=14f317ea&scoped=true&"
import script from "./CalificacionesParcialesPage.vue?vue&type=script&lang=js&"
export * from "./CalificacionesParcialesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f317ea",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/CalificacionesParcialesPage.vue
// module id = 207
// module chunks = 27